import React from 'react'
import Spinner from 'react-spinkit'

import styled from 'styled-components'

const LoadingWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1501;
  .spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    transform: translate(-50%, -50%);
    div {
      background-color: ${props => props.theme.palette.primary1Color};
    }
  }
`

const FullPageLoading = props => {
  return (
    <LoadingWrap>
      <Spinner fadeIn="none" name="cube-grid" className="spinner" />
    </LoadingWrap>
  )
}

FullPageLoading.propTypes = {}

export default FullPageLoading



// WEBPACK FOOTER //
// ./src/components/FullPageLoading/index.js